import {css, StyleSheet} from 'aphrodite';
import React, {ReactNode} from 'react';

export interface AntibodyInteractivityProps {
  hoveredRef: number | null;
  proteinIdsByRef: Record<number, string>;
  inaccessibleProteinIdsByRef: Record<number, string>;
  selectedRef: number | null;
  setHoveredRef: (newHoveredRef: number | null) => void;
  setSelectedRef: (newSelectedRefs: number | null) => void;
}

export interface InteractiveDomainWrapperProps {
  children: ReactNode;
  domainRef: number;
  interactivity?: AntibodyInteractivityProps;
}

export default function InteractiveDomainWrapper({
  children,
  domainRef,
  interactivity,
}: InteractiveDomainWrapperProps): JSX.Element {
  if (interactivity == null) {
    return <>{children}</>;
  }

  const disableClick = interactivity.inaccessibleProteinIdsByRef[domainRef] != null;

  return (
    <g
      className={css(disableClick ? styles.disabled : styles.group)}
      onClick={() => {
        if (disableClick) {
          return;
        }
        if (interactivity.selectedRef === domainRef) {
          interactivity.setSelectedRef(null);
        } else {
          interactivity.setSelectedRef(domainRef);
        }
      }}
      onMouseOver={() => {
        interactivity.setHoveredRef(domainRef);
      }}
      onMouseOut={() => {
        interactivity.setHoveredRef(null);
      }}
    >
      {children}
    </g>
  );
}

const styles = StyleSheet.create({
  group: {
    cursor: 'pointer',
  },
  disabled: {
    cursor: 'not-allowed',
  },
});
